<script setup>
const props = defineProps({
  hall: { type: Object, required: true },
  poster: {
    type: String,
    required: true
  },
  placeComponent: { type: Object, required: true },
  popupComponent: { type: [Object, null], default: null },
  tickets: { type: Array, default: () => [] },
  cart: { type: Array, default: () => [] }
})
const emit = defineEmits(['addTicketToCart', 'removeTicketFromCart'])

function onAddTicketToCart(e) {
  emit('addTicketToCart', e)
}

function onRemoveTicketFromCart(e) {
  emit('removeTicketFromCart', e)
}


const route = useRoute()
const hall = reactive(props.hall)
const partherKeys = reactive(Object.keys(hall).reverse())
const zoom = ref(1)
const maxHeight = ref('-webkit-fill-available')

const getTicket = (row, place, amphitheater, poster) => {
  return undefined
}

const getPlacesKeys = (places) => {
  return Object.keys(places).sort((a, b) => {
    a = Number(a)
    b = Number(a)
    return a - b
  })
}

const onWindowResize = () => {
  const gutters = 16
  const windowWidth = window.innerWidth
  let minWidth = 1300
  maxHeight.value = '100%'
  if (route.params.id === 'short-parter') {
    minWidth = 1700
  }
  if (windowWidth < minWidth + gutters * 2) {
    zoom.value = windowWidth / (gutters * 2 + minWidth)
  } else {
    zoom.value = 1
  }
}

onMounted(() => {
  window.addEventListener('resize', onWindowResize)
  onWindowResize()
})

onUnmounted(() => {
  window.removeEventListener('resize', onWindowResize)
})
</script>

<template>
  <div :style="{ height: `${maxHeight}` }">
    <div
      class="grid gap-9 justify-center auto-rows-auto auto-cols-auto"
      :style="`transform: scale(${zoom});`"
    >
      <div class="flex flex-col space-y-4 justify-center items-center">
        <div class="flex flex-row space-x-4 max-w-max" v-for="rowKey in partherKeys" :key="rowKey">
          <div :key="rowKey + 'left'" class="parther__numb">
            <span>{{ rowKey }}</span>
          </div>
          <component
            :is="placeComponent"
            :popup-component="popupComponent"
            v-for="placeKey in getPlacesKeys(hall[rowKey])"
            class="parther__place"
            :key="`${rowKey}, ${placeKey}`"
            :row="rowKey"
            :place-key="placeKey"
            :place="hall[rowKey][placeKey]"
            :amphitheater="false"
            :parther="true"
            @add-ticket-to-cart="onAddTicketToCart"
            @remove-ticket-from-cart="onRemoveTicketFromCart"
            :tickets="tickets"
            :cart="cart"
          />
          <div :key="rowKey + 'right'" class="parther__numb">
            <span>{{ rowKey }}</span>
          </div>
        </div>
      </div>

      <div class="h-28 bg-dark-gray flex rounded-lg">
        <p class="m-auto text-xl2 text-white font-sans">Сцена</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.parther {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column-reverse;

  &__row {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    grid-template-rows: [row-start] 34px [row-end];
  }

  &__numb {
    cursor: default;
    color: gray;
    font-weight: 700;
    text-align: center;
    padding: 7px;
    height: 34px;
    width: 34px;
  }
}

.footbuy {
  text-align: center;
  font-size: 25px;
  text-transform: uppercase;
  color: #fff;
  font-family: "ConvMuseoSansCyrl900";
  border: 20px solid transparent;
  border-top: 50px solid gray;
  width: 400px;
  margin: 0 auto;
  display: block;
  margin-top: 40px;
  padding: 5px;
  padding-bottom: 0px;
  p {
    color: #000 !important;
  }
}
</style>
